export default __webpack_public_path__ + "static/top_header_art_double_tab-f3411ceedddaaebfd34a2e5510ad331d.png";